var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBadge)?_c('span',{class:['badge', `badge--${_vm.type}`, _vm.customClass],attrs:{"data-cy":_vm.dataCy}},[_vm._v(" "+_vm._s(_vm.count)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }